import { AutoComplete } from "primereact/autocomplete";
import { useState } from "react";
import { useSelector } from "react-redux";
import { createSearchParams, useNavigate, useLocation } from "react-router-dom";
import "./style.css";
import AuxiliaryText from "../Typography/AuxiliaryText";

const SHELL_CLASS =
  "relative overflow-hidden w-[400px] h-[48px] md:w-[480px] md:h-[48px] xl:w-[600px] !rounded-[4px] placeholder-lightgray";

const AC_CLASS =
  "input-placeholder font-inter input-placeholder field-extra-large focus:border focus:border-primaryblue placeholder-lightgray placeholder:font-inter text-offblack font-inter rounded-[4px] w-[400px] h-[48px] md:w-[480px] md:h-[48px] xl:w-[600px] xl:h-[48px] bg-transparent";

const BTN_CLASS =
  "h-[48px] flex justify-center items-center group group-hover:cursor-pointer mr-4 absolute right-0 top-0";

export default function SearchInput({ className = "", ...restProps }) {
  const [searchData, setSearchData] = useState(null);
  const [filterCategory, setFilterCategory] = useState(null);
  const location = useLocation();

  const businessCategories = useSelector(
    (category) => category.BusinessCategoryReducer
  );

  const searchCategory = (event) => {
    setTimeout(() => {
      let _filterCategory;
      if (!event.query.trim().length) {
        _filterCategory = [...businessCategories];
      } else {
        _filterCategory = businessCategories.filter((category) => {
          return category.businessCategoryName
            .toLowerCase()
            .startsWith(event.query.toLowerCase());
        });
      }

      setFilterCategory(_filterCategory);
    }, 250);
  };

  const navigate = useNavigate();
  const onCategoryPage =
    location?.pathname?.includes("Services") ||
    location?.pathname === "/category" ||
    location?.pathname?.startsWith("/category/");

  const placeholder = onCategoryPage
    ? "Effortlessly find the services! "
    : "Need a service now? ";

  const navigateToResult = () => {
    if (typeof searchData === "object" && searchData) {
      navigate({
        pathname: "/Services",
        search: `?${createSearchParams({
          id: searchData?.id,
        })}`,
      });
    }
  };

  return (
    <div className={className}>
      <label className="mb-2 block">
        <AuxiliaryText variant={"FieldLabel"}>Keywords</AuxiliaryText>
      </label>
      <div className={SHELL_CLASS}>
        <AutoComplete
          {...restProps}
          className={AC_CLASS}
          placeholder={placeholder}
          value={searchData}
          suggestions={filterCategory}
          completeMethod={searchCategory}
          field="businessCategoryName"
          onChange={(e) => setSearchData(e.value)}
          aria-label="Categories"
          dropdownAriaLabel="Select Category"
          onKeyDown={(e) => {
            if (e.keyCode === 13) {
              navigateToResult();
            }
          }}
        />
        <button
          className={BTN_CLASS}
          type="submit"
          onClick={navigateToResult}
        >
          <i className="fi fi-rs-search text-base text-offblack flex items-center" />
        </button>
      </div>
    </div>
  );
}
